import React from 'react';

const STATUS_MAP = {
    waiting: { label: 'Waiting', color: '#f59e0b', bg: '#fef3c7' },
    open:    { label: 'Open',    color: '#10b981', bg: '#d1fae5' },
    closed:  { label: 'Closed', color: '#6b7280', bg: '#f3f4f6' },
};

const ChatStatusBadge = ({ status }) => {
    const cfg = STATUS_MAP[status] || STATUS_MAP.closed;
    return (
        <span
            className="chat-status-badge"
            style={{ color: cfg.color, background: cfg.bg, border: `1px solid ${cfg.color}40` }}
        >
            {cfg.label}
        </span>
    );
};

export default ChatStatusBadge;
